// TODO list
// Create wishlist page template and init code - DONE
// Create header with title, desc and action buttons - DONE
// Create product grid - DONE
// Basic styling of grid - DONE
// Fetch actual products for render - DONE
// Add pop-up modal for login and share - DONE
// Add handleOutsideClick listeners - DONE
// Make cart button functional - DONE
// Add remove API call to remove button - DONE
// Add no product found "continue shopping" screen - DONE
// Add API calls and state handling for modals - DONE
// Change default wishlist page URL - DONE
// Mobile styles - DONE
// Testing and polishing stuffs
// -- Correct product rendering order - DONE
// -- Show share only when user is logged in - DONE
// -- Show blank screen when all products are deleted from list - DONE

function swymCallbackFn(swat){
  var strings = swat.retailerSettings.Strings;
  var markUps = {
    emptyWishlist: `
		<div class="swym-cwl-empty-home">
			<span>You have not added any items to your wishlist.
				Add some items and visit this page again to view and modify your favourites.
			</span>
			<button class="swym-cwl-continue-shopping">{{EmptyWishlistsCTA}}</button>
		</div>
	`,
    headerAction: `
	<div class="swym-cwl-header-action-container">
      <button class="swym-cwl-save-wl-btn">Save your wishlist</button> | <button class="swym-cwl-share-wl-btn">Share your wishlist</button>
    </div>
	`,
    productGridContainer: `<ul class="swym-cwl-product-grid-container"></ul>`,
    productTile: `
	<li class="swym-cwl-product-tile">
		<form action="/cart/add" class="form" data-product-id="{{ productListId }}" enctype="multipart/form-data" id="{{ productListId }}" method="post">
			<a href={{ du }}>
	            <div class="swym-cwl-image-container">
	                <img src="{{ iu }}"></img>
	            </div>
	            <div class="swym-cwl-info-container">
	                <div class="swym-cwl-info-left">
	                    <span class="swym-cwl-dt">{{ dt }}</span>
	                    <span>{{ variantLabel1 }}</span>
	                </div>
	                <div>
	                    <span>{{ variantLabel2 }}</span>
	                </div>
	            </div>
			</a>
			<div class="swym-cwl-action-buttons">
				<select
					class="collection_variant collection_variant-{{ productListId }} js-quickview-select hide"
					name="id"
					id="size-{{ productListId }}"
					tabindex="-1"
					data-variants-data="{{ result.variants }}"
					data-variants-inventory="{{ result.mfield_product_online_inventory }}"
				>
					<option value="{{ productListId }}" selected>{{ productListId }}</option>
				</select>
				<div class="input-row">
					<div>
						<input
							cart-id="{{ productListId }}"
							class="add_to_cart cart_{{ productListId }} swym-cwl-cart-button"
	 						type="submit"
							value="{{ addToCartCTA }}"
						/>
					</div>
					<h6 class="h1-style price">
						<span>{{ pr }} {{ currency }}</span>
					</h6>
				</div>
				<button type="button" class="swym-cwl-remove-button">Remove</button>
			</div>
		</form>
	</li>`,
    saveModal: `
		<div class="swym-cwl-modal-container">
			<div class="swym-modal-bg"></div>
			<div class="swym-cwl-modal-content">
              	<span class="swym-cwl-modal-title">{{SaveListPopupFormHeading}}</span>
				{{#loggedInEmail}}
					<span class="swym-cwl-modal-desc">You are already logged in as<p>{{loggedInEmail}}</p></span>
				{{/loggedInEmail}}
				{{^loggedInEmail}}
                    <span class="swym-cwl-modal-desc">You are currently shopping anonymously. Please log in to save or share your wishlist.</span>
                    <button class="swym-cwl-login-btn">{{SaveListPopupSummaryCTALogin}}</button>
				{{/loggedInEmail}}
                <button class="swym-cwl-close-button">X</button>
			</div>
		</div>
	`,
    shareModal: `
		<div class="swym-cwl-modal-container">
			<div class="swym-modal-bg"></div>
			<div class="swym-cwl-modal-content swym-cwl-share-modal">
				<span class="swym-cwl-modal-title">{{ShareWishlistPopupHeading}}</span>
				<div class="swym-cwl-input-container">
					<label>{{ShareWishlistSenderName}}</label>
					<input class="swym-cwl-sender-name" placeholder="{{ShareWishlistNamePlaceholder}}"></input>
				</div>
                <div class="swym-cwl-input-container">
					<label>{{ShareWishlistRecipientsEmail}}<span class="swym-cwl-mandatory">*</span></label>
					<input class="swym-cwl-recipient-email" placeholder="{{ShareWishlistEmailPlaceholder}}"></input>
                </div>
				<div class="swym-cwl-input-container">
					<label>{{ShareWishlistMessage}}</label>
					<textarea class="swym-cwl-note" placeholder="{{ShareWishlistNotePlaceholder}}"></textarea>
				</div>
				<div class="swym-cwl-share-button-container">
					<button class="swym-cwl-share-btn">{{ShareWishlistEmailCTA}}</button>
				</div>
				<div class="swym-cwl-separator"></div>
				<span class="swym-cwl-social-share-title">{{ShareWishlistAlternateShareLabel}}</span>
				<div class="swym-cwl-social-share-container">
					<button class="swym-cwl-copy-link">
						<span class="swym-cwl-icon"></span>
						<span>{{ShareWishlistCopyLinkText}}</span>
					</button>
					<button class="swym-cwl-fb-share">
						<span class="swym-cwl-icon"></span>
						<span>{{ShareWishlistFacebook}}</span>
					</button>
					<button class="swym-cwl-twitter-share">
						<span class="swym-cwl-icon"></span>
						<span>{{ShareWishlistTwitter}}</span>
					</button>
				</div>
				<button class="swym-cwl-close-button">X</button>
			</div>
	`
  };
  var wishlistContainerElem = document.querySelector(".swym-cwl-container");
  function showErrorNotification() {
    swat.ui.uiRef.showErrorNotification({message: strings.ServerError});
  }
  function copyTextToClipboard(text, successCb, errorCb) {
    var clipBoardElem = document.createElement("input");
    document.body.appendChild(clipBoardElem);
    clipBoardElem.value = text;
    clipBoardElem.select();
    try {
      const successfulCopy = document.execCommand('copy');
      if(successCb) {
        successCb()
      };
    } catch (err) {
      if(errorCb) {
        errorCb(err)
      }
    }
    document.body.removeChild(clipBoardElem)
  }
  function getAddToCartCTA(variantObj) {
   	var swymCartItems = window.swymCart && swymCart.items, returnStr;
    var relevantSwymCartItem = [];
    if (swymCartItems && swymCartItems.length) {
      relevantSwymCartItem = swymCartItems.filter(function(v) {
        return v.id === variantObj.id
      });
    }
    if (relevantSwymCartItem.length) {
      returnStr = 'Add To Cart';
    } else if (!variantObj.available) {
      returnStr = strings.SoldOutCTA;
    } else {
      returnStr = 'Add to Cart';
    }
	return returnStr;
  }
  function closeSwymModal() {
    SwymUtils.removeSelectedElement(".swym-cwl-modal-container");
  }
  function addOutsideClickHandler() {
    document.addEventListener("click", function outsideClickHandler(evt) {
      var modalElement = document.querySelector('.swym-cwl-modal-content'),
          targetElement = evt.target;
      do {
        if (targetElement == modalElement) {
          return;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);
      closeSwymModal();
      document.removeEventListener("click", outsideClickHandler);
    });
  }
  function initModalFunctionality(modalType) {
    var closeModalBtn = document.querySelector(".swym-cwl-close-button");
    closeModalBtn.onclick = closeSwymModal;
    addOutsideClickHandler();
    if (modalType === "saveModal") {
      var loginButtonElem = document.querySelector(".swym-cwl-login-btn");
      if (loginButtonElem) {
        loginButtonElem.onclick = function() {
          location.href = "/account/login";
        }
      }
      // Add button handler for login button
    } else if (modalType === "shareModal") {
      var senderNameInput = document.querySelector(".swym-cwl-sender-name");
      var recipientEmailInput = document.querySelector(".swym-cwl-recipient-email");
      var noteInput = document.querySelector(".swym-cwl-note");
      var shareListBtnElem = document.querySelector(".swym-cwl-share-btn");
      var copyLinkBtnElem = document.querySelector(".swym-cwl-copy-link");
      var fbShareBtnElem = document.querySelector(".swym-cwl-fb-share");
      var twitterShareBtnElem = document.querySelector(".swym-cwl-twitter-share");
      var fbShareMode = swat.retailerSettings.Wishlist.SharingModes.filter(v => v.type === "facebook")[0];
      var twitterShareMode = swat.retailerSettings.Wishlist.SharingModes.filter(v => v.type === "twitter")[0];
      shareListBtnElem.onclick = function() {
        swat.sendListViaEmail(
          {
            toEmailId: recipientEmailInput.value,
            fromName: senderNameInput.value || "",
            note: noteInput.value || "",
            lid: null,
          },
          function(r) {
            swat.ui.uiRef.showSuccessNotification({message: "Wishlist has been shared"});
          },
          function(r) {
            showErrorNotification();
          }
        );
      }
      shareListBtnElem.disabled = true;
      SwymUtils.addClass(shareListBtnElem, "swym-cwl-disabled");
      recipientEmailInput.onchange = function(e) {
        var inputVal = e.target.value;
        if (inputVal && !SwymUtils.validateEmail(inputVal)) {
          SwymUtils.addClass(recipientEmailInput, "swym-cwl-invalid-input");
          recipientEmailInput.parentNode.appendChild(
            SwymUtils.createElement("<label class='swym-cwl-email-error swym-cwl-mandatory'>Please enter a valid email address</label>")
          );
        } else {
          var errorIndicatorElem = recipientEmailInput.parentNode.querySelector(".swym-cwl-email-error");
          errorIndicatorElem && errorIndicatorElem.parentNode.removeChild(errorIndicatorElem);
          shareListBtnElem.disabled = !!!inputVal;
          SwymUtils.removeClass(shareListBtnElem, "swym-cwl-disabled");
          SwymUtils.removeClass(recipientEmailInput, "swym-cwl-invalid-input");
        }
      }
      if (copyLinkBtnElem) {
        copyLinkBtnElem.onclick = function() {
          swat.generateSharedListURL(
            null,
            function(data, sharedListId) {
              copyTextToClipboard(data, function() {
                swat.ui.uiRef.showSuccessNotification({message: "Link copied to clipboard"});
              })
            },
            function(data) { showErrorNotification(); }
          );
        }
      }
      if (fbShareBtnElem) {
        fbShareBtnElem.onclick = function() {
          swat.shareListSocial(
            null,
            senderNameInput.value || "",
            fbShareMode.url,
            fbShareMode.type,
            noteInput.value || "",
            function(data) { console.log(data) }
          );
        }
      }
      if (twitterShareBtnElem) {
        twitterShareBtnElem.onclick = function() {
          swat.shareListSocial(
            null,
            senderNameInput.value || "",
            twitterShareMode.url,
            twitterShareMode.type,
            noteInput.value || "",
            function(data) { console.log(data) }
          );
        }
      }
      // Handle social shares
    }
  }
  function renderEmptyWishlistScreen() {
    var emptyWishlistMarkup = SwymUtils.renderTemplateString(markUps.emptyWishlist, strings);
    wishlistContainerElem.appendChild(SwymUtils.createElement(emptyWishlistMarkup));
    var continueShoppingBtnElem = document.querySelector(".swym-cwl-continue-shopping");
    continueShoppingBtnElem.onclick = function() {
      window.location.href = window.location.origin;
    }
  }
  function handleItemRemove(itemData, nodeElem) {
    swat.removeFromWishList(itemData, function() {
      nodeElem.parentNode.removeChild(nodeElem);
      var productGridContainerElem = document.querySelector(".swym-cwl-product-grid-container");
      if (!productGridContainerElem.childElementCount) {
        var children = wishlistContainerElem.childNodes;
        var childrenArr = Array.prototype.slice.call(children);
        childrenArr.forEach(c => c.parentNode.removeChild(c));
        renderEmptyWishlistScreen();
      }
    }, function() {
      showErrorNotification();
    });
  }
  function initializeCartButton(cartButtonElem, productData) {
    var cartButtonInnerText = cartButtonElem.value.toLowerCase();
    if (cartButtonInnerText === strings.SoldOutCTA.toLowerCase()) {
      SwymUtils.addClass(cartButtonElem, "swym-cwl-disabled");
      cartButtonElem.disabled = true;
    } else if (cartButtonInnerText === strings.ViewCartCTA.toLowerCase()) {
      cartButtonElem.onclick = function() {
        cartButtonElem.firstElementChild.innerText = "Redirecting...";
        cartButtonElem.disabled = true;
        swat.openCartPage();
      }
    } else {
      cartButtonElem.onclick = function() {
        if (cartButtonInnerText === strings.AddToCartCTA.toLowerCase()) {
          cartButtonElem.firstElementChild.innerText = strings.AddToCartCTAAdding;
          cartButtonElem.disabled = true;
          var cartData = Object.assign({}, productData);
          cartData.product = productData;
          cartData.callback = function() {
            cartButtonElem.firstElementChild.innerText = strings.ViewCartCTA;
            cartButtonElem.disabled = false;
            cartButtonElem.onclick = function() {
              swat.openCartPage();
            }
          }
          cartData.errorCallback = function() {
         	showErrorNotification();
          }

          swat.platform.addToCart(cartData);
        }
      }
    }
  }
  var loggedInUserEmail = swat.getSwymEmail();
  swat.fetch(function(products) {
    if (products.length) {
      var headerActionElem = SwymUtils.createElement(markUps.headerAction);
      wishlistContainerElem.appendChild(headerActionElem);
      var productGridContainerElem = SwymUtils.createElement(markUps.productGridContainer);
      wishlistContainerElem.appendChild(productGridContainerElem);
      var productDetailsArr = [];
      swat.fetchProductForItems(products, function(productDetails) {
        var isDupe = productDetailsArr.filter(p => p.listItem.epi === productDetails.listItem.epi).length;
        if (!isDupe) {
          productDetailsArr.push(productDetails);
        }
        if (productDetailsArr.length === products.length) {
          if (!productGridContainerElem.childElementCount) {
            var sortedProductArr = productDetailsArr.sort((a, b) => b.listItem.cts - a.listItem.cts);
            sortedProductArr.forEach(productDetails => {
              var currentProduct = Object.assign({}, productDetails.listItem);
              currentProduct.dt = productDetails.variantDetail.option1;
              currentProduct.productListId = productDetails.variantDetail.id;
              currentProduct.variantLabel1 = productDetails.variantDetail.option2;
              currentProduct.variantLabel2 = productDetails.variantDetail.option3;
              currentProduct.addToCartCTA = getAddToCartCTA(productDetails.variantDetail);
              currentProduct.currency = Shopify.currency.active;
              var currentProductMarkup = SwymUtils.renderTemplateString(markUps.productTile, currentProduct);
              var productTileElem = SwymUtils.createElement(currentProductMarkup);
              productGridContainerElem.appendChild(productTileElem);
              // Init remove and cart buttons
              var removeButtonElem = productTileElem.querySelector(".swym-cwl-remove-button");
              removeButtonElem.onclick = function() {
                handleItemRemove(productDetails.listItem, productTileElem);
              }
              var cartButtonElem = productTileElem.querySelector(".swym-cwl-cart-button");
              initializeCartButton(cartButtonElem, productDetails.listItem);
            })
          }
        }
      }, function() {}, function() {});
      // Add handler to create and show modals
      var menuButtonsArr = [
        {
          selector: ".swym-cwl-save-wl-btn",
          markupKey: "saveModal",
        },
        {
          selector: ".swym-cwl-share-wl-btn",
          markupKey: "shareModal"
        }
      ];
      for (var i = 0, len = menuButtonsArr.length; i < len; i++) {
        (function() {
          var currentMenuItem = menuButtonsArr[i];
          var buttonElem = document.querySelector(currentMenuItem.selector);
          buttonElem.onclick = (e) => {
            e.stopPropagation();
            var templateData = Object.assign({}, strings);
            templateData.loggedInEmail = loggedInUserEmail;
            var modalMarkup = SwymUtils.renderTemplateString(markUps[currentMenuItem.markupKey], templateData);
            document.body.appendChild(SwymUtils.createElement(modalMarkup));
            initModalFunctionality(currentMenuItem.markupKey);
          }
        })();
      }
    } else {
      renderEmptyWishlistScreen();
    }
  });
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
